/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";


// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

// Presentation page sections
import Counters from "pages/Presentation/sections/Counters";
import Information from "pages/Presentation/sections/Information";
import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
import Pages from "pages/Presentation/sections/Pages";
import Testimonials from "pages/Presentation/sections/Testimonials";
import Download from "pages/Presentation/sections/Download";
import Fidlogo from "../../assets/images/logo-fid.png"
import data from "pages/Presentation/sections/data/pagesData";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';

// Presentation page components
import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";
import { CircleLoader } from 'react-spinners'
// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/bg-presentation.jpg";
import D from "../../assets/images/Fidelity/D.jpg"
import { Link } from "react-router-dom";
import ExampleCard from "./components/ExampleCard";
import { Accordion, AccordionDetails, AccordionSummary, AccordionActions, Button, Box, Typography } from "@mui/material";
import { get } from "utility/fetch";
import { useState } from "react";
import { useEffect } from "react";
import { numberWithCommas } from "utility/general";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function Presentation() {

  const [balanceBreakdown, setBalanceBreakdown] = useState([]);
  const [balance, setBalance] = useState([]);
  const [fiveTrx, setFiveTrx] = useState([]);

  const [baLoading, setBaLoading] = useState(false);
  const [brLoading, setBrLoading] = useState(false);
  const [fiLoading, setFiLoading] = useState(false);

  const [viewBalance, setViewBalance] = useState(false);
  const [viewAVC, setViewAVC] = useState(false);
  const [viewNormal, setViewNormal] = useState(false);
  const [viewGrowth, setViewGrowth] = useState(false);


  const getBalanceBreakdown = async () => {
    setBrLoading(true);
    let res = await get(`/balance-breakdown/${sessionStorage.getItem("pin")}`)
    console.log(res);
    setBalanceBreakdown(res.data.data);
    setBrLoading(false);
  }

  const getBalance = async () => {
    setBaLoading(true);
    let res = await get(`/balance/${sessionStorage.getItem("pin")}`)
    console.log(res);
    setBalance(res.data.data);
    setBaLoading(false);
  }

  const getFiveTrx = async () => {
    setFiLoading(true);
    let res = await get(`/five-customer-transation/${sessionStorage.getItem("pin")}`)
    console.log(res);
    setFiveTrx(res.data.data);
    setFiLoading(false);
  }

  useEffect(() => {
    getBalanceBreakdown();
    getFiveTrx();
    getBalance();
  }, [])

  return (
    <div sx={{ width: "100%" }}>
      <DefaultNavbar
        routes={routes}
        action={{
          route: "https://www.creative-tim.com/product/material-kit-react",
          label: "free download",
          color: "info",
        }}
        sticky
      />
      <MKBox
        minHeight="60vh"
        width="100%"
        sx={{
          backgroundImage: `url(${D})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top",
          // display: "grid",
          placeItems: "center",
        }}
      >
        <Container xs={12} sm={12}>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="white"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              {/* <img src={Fidlogo} alt="Fid-logo" /> */}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="white"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >

            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        className="rough-bg"
        sx={{
          p: 2,
          mx: { xs: 0, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
          justifyContent: "center"
        }}
      >
        <Grid item xs={12} lg={12} sx={{ mt: 3, px: { xs: 0, lg: 8 } }}>
          <Grid container
            direction="column"
            alignItems="center"
            justifyContent="center" spacing={3}>

            <Grid
              spacing={2}
              item xs={12} md={10} sx={{ mb: { xs: 3, lg: 0 }, justifyContent: { xs: "center", md: "center" } }}>

              <Card
                // className="card"
                sx={{
                  justifyContent: "center",
                  textAlign: "center",
                  padding: { lg: "2rem 6rem", xs: "2rem" },
                  width: { sm: "80%", md: "100%", },
                  position: "relative"
                }}
              >
                {!viewBalance ? <Visibility color="#4A5D23" onClick={() => setViewBalance(true)} fontSize="40" sx={{ position: "absolute", top: 16, right: 16, cursor: "pointer", fontSize: "30px", color: "#4A5D23" }} />
                  :
                  <VisibilityOff color="#4A5D23" onClick={() => setViewBalance(false)} fontSize="40" sx={{ position: "absolute", top: 16, right: 16, cursor: "pointer", fontSize: "30px", color: "#4A5D23" }} />
                }
                <h4>
                  RSA Balance
                </h4>
                <h1>
                  {baLoading ? <CircleLoader /> : (viewBalance) ? numberWithCommas(balance?.rsaBalance) : "**********"}
                </h1>
              </Card>

            </Grid>

            <Grid container item
              direction="row"
              justifyContent={"center"}
              spacing={3}>

              <Grid item xs={9} md={9} lg={4}>
                <Card
                  sx={{
                    justifyContent: "center",
                    textAlign: "center",
                    padding: "2rem 4rem",
                  }}
                >
                  {!viewNormal ? <Visibility color="#4A5D23" onClick={() => setViewNormal(true)} fontSize="40" sx={{ position: "absolute", top: 16, right: 16, cursor: "pointer", fontSize: "30px", color: "#4A5D23" }} />
                    :
                    <VisibilityOff color="#4A5D23" onClick={() => setViewNormal(false)} fontSize="40" sx={{ position: "absolute", top: 16, right: 16, cursor: "pointer", fontSize: "30px", color: "#4A5D23" }} />
                  }
                  <h4>
                    Normal Contribution
                  </h4>
                  <h2>
                    {brLoading ? <CircleLoader /> : (viewNormal) ? numberWithCommas(balanceBreakdown?.normalContribution) : "**********"}
                  </h2>
                </Card>
              </Grid>
              <Grid item xs={9} md={9} lg={4}>
                <Card
                  sx={{
                    justifyContent: "center",
                    textAlign: "center",
                    padding: "2rem 4rem",
                  }}
                >
                  {!viewAVC ? <Visibility color="#4A5D23" onClick={() => setViewAVC(true)} fontSize="40" sx={{ position: "absolute", top: 16, right: 16, cursor: "pointer", fontSize: "30px", color: "#4A5D23" }} />
                    :
                    <VisibilityOff color="#4A5D23" onClick={() => setViewAVC(false)} fontSize="40" sx={{ position: "absolute", top: 16, right: 16, cursor: "pointer", fontSize: "30px", color: "#4A5D23" }} />
                  }
                  <h4>
                    Voluntary Contribution
                  </h4>
                  <h2>
                    {brLoading ? <CircleLoader /> : (viewAVC) ? numberWithCommas(balanceBreakdown?.avc) : "**********"}
                  </h2>
                </Card>
              </Grid>
              <Grid item xs={9} md={9} lg={4}>
                <Card
                  sx={{
                    justifyContent: "center",
                    textAlign: "center",
                    padding: "2rem 4rem",
                  }}
                >
                  {!viewGrowth ? <Visibility color="#4A5D23" onClick={() => setViewGrowth(true)} fontSize="40" sx={{ position: "absolute", top: 16, right: 16, cursor: "pointer", fontSize: "30px", color: "#4A5D23" }} />
                    :
                    <VisibilityOff color="#4A5D23" onClick={() => setViewGrowth(false)} fontSize="40" sx={{ position: "absolute", top: 16, right: 16, cursor: "pointer", fontSize: "30px", color: "#4A5D23" }} />
                  }
                  <h4>
                    Growth
                  </h4>
                  <h2>
                    {fiLoading ? <CircleLoader /> : (viewGrowth) ? numberWithCommas((parseFloat(balance?.rsaBalance) - parseFloat(balanceBreakdown?.normalContribution) - parseFloat(balanceBreakdown?.avc)).toFixed(2)) : "**********"}
                  </h2>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* <Counters /> */}
        {/* <Information /> */}
        {/* <DesignBlocks /> */}
        {/* <Pages /> */}
        {/* <Container sx={{ mt: 6 }}>
          <BuiltByDevelopers />
        </Container> */}
        <Typography variant="h3" sx={{ mt: 3 }} textAlign={"center"}>
          Recent Transactions
        </Typography>
        {Array.isArray(fiveTrx) && fiveTrx.length > 0 && fiveTrx.map((item) => (
          <Grid container xs={12} direction={"column"} sx={{ mt: 2, justifyItems: "center", width: "100%", alignContent: "center", justifyContent: "center" }}>
            <Grid item xs={12} md={9} lg={10} sx={{ width: { xs: "100%", md: "80%" } }} >

              <Accordion xs={10} md={10}>
                <AccordionSummary
                  // expandIcon={<ExpandMoreIcon />}
                  sx={{ width: "100%" }}
                  justifyContent="spaceBetween"
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Grid sx={{ width: "100%", alignItems: "center", alignContent: "spaceBetween", justifyContent: "center" }} container direction="row">
                    <Grid item xs={2}>
                      <ArrowCircleDownIcon fontSize="large" color="success" />
                    </Grid>

                    <Grid container alignContent={"center"} xs={4} direction={"column"} item>
                      <Grid item xs={4}>
                        {item?.narration}
                      </Grid>

                      <Grid item xs={4}>
                        {new Date(item?.valueDate).toDateString()}
                      </Grid>
                    </Grid>

                    <Grid textAlign={"end"} item xs={6}>
                      {`N${numberWithCommas(item?.totalContribution)}`}
                    </Grid>

                  </Grid>
                </AccordionSummary>
                <AccordionDetails sx={
                  {
                    borderTop: "1px solid black",
                  }
                }>
                  <Grid container direction={"column"} sx={{ borderTop: "1px", justifyItems: "center", alignContent: "center", justifyContent: "center" }}>
                    <Grid item sx={{ textAlign: "center", borderTop: "1px", marginRight: "5px", justifyItems: "center", alignContent: "center", justifyContent: "center" }}>
                      <ArrowCircleDownIcon fontSize="large" color="success" />
                    </Grid>
                    <Grid item sx={{ textAlign: "center" }}>
                      <h3>{item?.narration}</h3>
                      <p>{new Date(item?.valueDate).toDateString()}</p>
                    </Grid>
                  </Grid>
                  <Grid container direction={"column"} sx={{ mt: 5, alignItems: "center", alignContent: "center" }}>
                    <Grid container sm={6} item flex sx={{ justifyContent: "space-between" }}>
                      <Grid item>
                        Employer Contribution
                      </Grid>
                      <Grid item>
                        {numberWithCommas(item?.employerContribution)}
                      </Grid>
                    </Grid>
                    <Grid container sm={6} item flex sx={{ justifyContent: "space-between" }} >
                      <Grid item>
                        Employee Contribution
                      </Grid>
                      <Grid item>
                        {numberWithCommas(item?.employeeContribution)}
                      </Grid>
                    </Grid>
                    <Grid container sm={6} item flex sx={{ justifyContent: "space-between" }} >
                      <Grid item>
                        Voluntary Contribution
                      </Grid>
                      <Grid item>
                        {numberWithCommas(item.avc)}
                      </Grid>
                    </Grid>
                    <Grid container sm={6} item flex sx={{ justifyContent: "space-between" }} >
                      <Grid item>
                        Fees
                      </Grid>
                      <Grid item>
                        {numberWithCommas(item?.fees)}
                      </Grid>
                    </Grid>
                    <Grid container sm={6} item flex sx={{ justifyContent: "space-between" }} >
                      <Grid item>
                        Total Amount
                      </Grid>
                      <Grid item>
                        {numberWithCommas(item?.totalContribution)}
                      </Grid>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

            </Grid>
          </Grid>
        ))
        }

        <Grid container direction={"column"} sx={{ mt: 5, justifyItems: "center", alignContent: "center", justifyContent: "center" }}>
          <Grid item xs={12}>
            <Link to="/pages/transactions">
              <Card sx={{ cursor: "pointer" }}>
                <Box sx={{ p: 2, textAlign: "center", }}>
                  View all transactions
                </Box>
              </Card>
            </Link>

          </Grid>


        </Grid>
        <Container>




          <Grid container spacing={3}>
            {/* <Grid item xs={12} lg={4}>
              <FilledInfoCard
                variant="gradient"
                color="info"
                icon="flag"
                title="Getting Started"
                description="Check the possible ways of working with our product and the necessary files for building your own project."
                action={{
                  type: "external",
                  route: "https://www.creative-tim.com/learning-lab/react/overview/material-kit/",
                  label: "Let's start",
                }}
              />
            </Grid> */}
            {/* <Grid item xs={12} lg={4}>
              <FilledInfoCard
                color="info"
                icon="precision_manufacturing"
                title="Plugins"
                description="Get inspiration and have an overview about the plugins that we used to create the Material Kit."
                action={{
                  type: "external",
                  route: "https://www.creative-tim.com/learning-lab/react/overview/datepicker/",
                  label: "Read more",
                }}
              />
            </Grid> */}
            {/* <Grid item xs={12} lg={4}>
              <FilledInfoCard
                color="info"
                icon="apps"
                title="Components"
                description="Material Kit is giving you a lot of pre-made components, that will help you to build UI's faster."
                action={{
                  type: "external",
                  route: "https://www.creative-tim.com/learning-lab/react/alerts/material-kit/",
                  label: "Read more",
                }}
              />
            </Grid> */}
          </Grid>
        </Container>
        {/* <Testimonials /> */}
        {/* <Download /> */}
        {/* <MKBox pt={18} pb={6}>
          <Container>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={5} ml="auto" sx={{ textAlign: { xs: "center", lg: "left" } }}>
                <MKTypography variant="h4" fontWeight="bold" mb={0.5}>
                  Thank you for your support!
                </MKTypography>
                <MKTypography variant="body1" color="text">
                  We deliver the best web products
                </MKTypography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={5}
                my={{ xs: 5, lg: "auto" }}
                mr={{ xs: 0, lg: "auto" }}
                sx={{ textAlign: { xs: "center", lg: "right" } }}
              >
                <MKSocialButton
                  component="a"
                  href="https://twitter.com/intent/tweet?text=Check%20Material%20Design%20System%20made%20by%20%40CreativeTim%20%23webdesign%20%23designsystem%20%23mui5&amp;url=https%3A%2F%2Fwww.creative-tim.com%2Fproduct%2Fmaterial-kit-react"
                  target=""
                  color="twitter"
                  sx={{ mr: 1 }}
                >
                  <i className="fab fa-twitter" />
                  &nbsp;Tweet
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://www.facebook.com/sharer/sharer.php?u=https://www.creative-tim.com/product/material-kit-react"
                  target=""
                  color="facebook"
                  sx={{ mr: 1 }}
                >
                  <i className="fab fa-facebook" />
                  &nbsp;Share
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://www.pinterest.com/pin/create/button/?url=https://www.creative-tim.com/product/material-kit-react"
                  target=""
                  color="pinterest"
                >
                  <i className="fab fa-pinterest" />
                  &nbsp;Pin it
                </MKSocialButton>
              </Grid>
            </Grid>
          </Container>
        </MKBox> */}
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </div>
  );
}

export default Presentation;
